const SYMBOL_MAP: { [prop: string]: string } = {
    CNY: '￥',
    USD: '$',
    JPY: 'JPY￥',
    TWD: 'NT$',
};

export const getLocalSymbol = (symbol: string) => {
    return SYMBOL_MAP[symbol];
};
